import { RouteConfig } from '../interfaces/routes-config.interface';
import { UserRole } from '../enums/user-role.enum';
// tslint:disable: no-console
console.group();
console.info('*** PUBLIC PATH *** ', process.env.PUBLIC_URL);
console.info('*** BE ROUTE ***', process.env.REACT_APP_BE_API_ENDPOINT);
console.groupEnd();
// tslint:enable: no-console
export const PUBLIC_PATH = process.env.PUBLIC_URL || '/';
export const SERVER_BASE_URL = process.env.REACT_APP_BE_API_ENDPOINT;
export const HOST_NAME = '//' + window.location.host;
export const WEBSITE_HOME = process.env.REACT_APP_WEBSITE_BASE || 'https://birdnestlife.com';
export const GOOGLE_CAPTCHA_KEY = process.env.REACT_APP_GOOGLE_CAPTCHA_KEY;

export const GES_PERMITTED_ROLES: UserRole[] = [
  UserRole.SUPER_ADMIN,
  UserRole.ADMIN,
  UserRole.GES,
  UserRole.OPERATION_MANAGER
];

export const CX_QUEUE_PERMITTED_ROLES: UserRole[] = [
  UserRole.SUPER_ADMIN,
  UserRole.ADMIN,
  UserRole.RESERVATIONS,
  UserRole.RESERVATION_MANAGER,
  UserRole.OPERATION_MANAGER
];

export const APP_ROUTES: RouteConfig = {
  HOME_MODULE: {
    PATH: '/home',
    FULL_PATH: '/home',
    DISPLAY_NAME: 'Dashboard',
    IS_MENU: true,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: false,
    NAME: 'home',
    ICON: `${PUBLIC_PATH}/assets/pngs/side-nav/home.png`
  },
  CALENDAR_MODULE: {
    PATH: '/calendar',
    FULL_PATH: '/calendar',
    DISPLAY_NAME: 'Calendar',
    NAME: 'Calendar',
    IS_MENU: true,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/dashboard.svg`,
    PERMITTED_ROLES: [UserRole.SUPER_ADMIN]
  },
  DASHBOARD_MODULE: {
    PATH: '/dashboard',
    FULL_PATH: '/dashboard',
    DISPLAY_NAME: 'Dashboard',
    NAME: 'dashboard',
    IS_MENU: false,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/dashboard.svg`,
    CHILDREN: {
      HOME: {
        PATH: '/home',
        FULL_PATH: '/dashboard/home',
        NAME: 'Home',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false
      }
    }
  },

  KPIS_MODULE: {
    PATH: '/kpis',
    FULL_PATH: '/kpis',
    DISPLAY_NAME: 'Kpis',
    NAME: 'Kpis',
    IS_MENU: false,
    IS_MENU_LOOKUP: true,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/kpis.svg`,
    CHILDREN: {
      HOME: {
        PATH: '/home',
        FULL_PATH: '/kpis/home',
        NAME: 'Kpis',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false
      }
      // BUSINESS_ON_THE_BOOK: {
      //   PATH: '/BusinessOnTheBook',
      //   FULL_PATH: '/kpis/BusinessOnTheBook',
      //   DISPLAY_NAME: 'Business on the book',
      //   NAME: 'Business on the book',
      //   ICON: `${PUBLIC_PATH}/assets/pngs/side-nav/area.png`,
      //   IS_MENU: false,
      //   IS_MENU_LOOKUP: true,
      //   IS_MENU_USERS: false
      // }
    }
  },
  OCCUPANCY_RATE_MODULE: {
    PATH: '/occupancy-rate',
    FULL_PATH: '/occupancy-rate',
    DISPLAY_NAME: 'Occupancy rate',
    NAME: 'Occupancy rate',
    IS_MENU: false,
    IS_MENU_LOOKUP: true,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/occupancy-rate.svg`,
    PERMITTED_ROLES: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.SALES_SPECIALIST,
      UserRole.ECOMMERCE_SENIOR_SPECIALIST,
      UserRole.ECOMMERCE_SPECIALIST,
      UserRole.SALES_MANAGER,
      UserRole.OPERATION_MANAGER
    ]
  },
  WEBSITE_SORT_MODULE: {
    PATH: '/website-sort',
    FULL_PATH: '/website-sort',
    DISPLAY_NAME: 'Website Sort',
    NAME: 'Website Sort',
    IS_MENU: false,
    IS_MENU_LOOKUP: true,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/occupancy-rate.svg`,
    PERMITTED_ROLES: [UserRole.SUPER_ADMIN]
  },
  AUTH_MODULE: {
    PATH: '/auth',
    FULL_PATH: '/auth',
    NAME: 'auth',
    IS_MENU: false,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: false,
    CHILDREN: {
      LOGIN: {
        PATH: '/login',
        FULL_PATH: '/auth/login',
        NAME: 'Sign in',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false
      },
      RESET_PASSWORD: {
        PATH: '/reset-password',
        FULL_PATH: '/auth/reset-password',
        NAME: 'Reset password',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false
      },
      FORGOT_PASSWORD: {
        PATH: '/forgot-password',
        FULL_PATH: '/auth/forgot-password',
        NAME: 'Forgot password',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false
      },
      UNAUTHORIZED: {
        PATH: '/unauthorized',
        FULL_PATH: '/auth/unauthorzied',
        NAME: 'Unauthorized',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false
      }
    }
  },
  AREA_MODULE: {
    PATH: '/areas',
    FULL_PATH: '/areas',
    DISPLAY_NAME: 'Areas',
    NAME: 'areas',
    IS_MENU: false,
    IS_MENU_LOOKUP: true,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/location.svg`,
    PERMITTED_ROLES: [
      UserRole.E_COMMERCE,
      UserRole.ECOMMERCE_SPECIALIST,
      UserRole.OPERATION_MANAGER,
      UserRole.ECOMMERCE_SENIOR_SPECIALIST,
      UserRole.ADMIN,
      UserRole.SUPER_ADMIN
    ],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/areas/list',
        NAME: 'Areas List',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.E_COMMERCE,
          UserRole.ECOMMERCE_SPECIALIST,
          UserRole.OPERATION_MANAGER,
          UserRole.ECOMMERCE_SENIOR_SPECIALIST,
          UserRole.ADMIN,
          UserRole.SUPER_ADMIN
        ]
      }
    }
  },
  UNIT_TYPE_GROUP_MODULE: {
    PATH: '/unitTypeGroups',
    FULL_PATH: '/unitTypeGroups',
    DISPLAY_NAME: 'Accommodation Types',
    NAME: 'unitTypeGroups',
    IS_MENU: false,
    IS_MENU_LOOKUP: true,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/accommodation.svg`,
    PERMITTED_ROLES: [
      UserRole.E_COMMERCE,
      UserRole.ECOMMERCE_SPECIALIST,
      UserRole.ECOMMERCE_SENIOR_SPECIALIST,
      UserRole.ADMIN,
      UserRole.SUPER_ADMIN
    ],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/unitTypeGroups/list',
        NAME: 'Accommodation Type List',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.E_COMMERCE,
          UserRole.ECOMMERCE_SPECIALIST,
          UserRole.ECOMMERCE_SENIOR_SPECIALIST,
          UserRole.ADMIN,
          UserRole.SUPER_ADMIN
        ]
      }
    }
  },
  AMENITY_MODULE: {
    PATH: '/amenity',
    FULL_PATH: '/amenity',
    DISPLAY_NAME: 'Amenities',
    NAME: 'amenity',
    IS_MENU: false,
    IS_MENU_LOOKUP: true,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/amenities.svg`,
    PERMITTED_ROLES: [
      UserRole.E_COMMERCE,
      UserRole.ECOMMERCE_SPECIALIST,
      UserRole.ECOMMERCE_SENIOR_SPECIALIST,
      UserRole.ADMIN,
      UserRole.SUPER_ADMIN
    ],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/amenity/list',
        NAME: 'Amenities List',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.E_COMMERCE,
          UserRole.ECOMMERCE_SPECIALIST,
          UserRole.ECOMMERCE_SENIOR_SPECIALIST,
          UserRole.ADMIN,
          UserRole.SUPER_ADMIN
        ]
      }
    }
  },
  USER_MODULE: {
    PATH: '/user',
    FULL_PATH: '/user',
    DISPLAY_NAME: 'User Search',
    NAME: 'user',
    IS_MENU: false,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: true,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/user-profile.svg`,
    PERMITTED_ROLES: [
      UserRole.E_COMMERCE,
      UserRole.ECOMMERCE_SPECIALIST,
      UserRole.ECOMMERCE_SENIOR_SPECIALIST,
      UserRole.SALES_SPECIALIST,
      UserRole.SALES_MANAGER,
      UserRole.ADMIN,
      UserRole.SUPER_ADMIN,
      UserRole.RESERVATIONS,
      UserRole.RESERVATION_MANAGER,
      UserRole.RESERVATION_AGENT,
      UserRole.HOSPITALITY_MANAGER,
      UserRole.HOSPITALITY_AGENT,
      UserRole.GES,
      UserRole.OPERATION_MANAGER,
      UserRole.COMMERCIAL_MANAGER
    ],
    CHILDREN: {
      SEARCH: {
        PATH: '/search',
        FULL_PATH: '/user/search',
        NAME: 'User Search',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: true,
        PERMITTED_ROLES: [
          UserRole.E_COMMERCE,
          UserRole.ECOMMERCE_SPECIALIST,
          UserRole.ECOMMERCE_SENIOR_SPECIALIST,
          UserRole.SALES_SPECIALIST,
          UserRole.SALES_MANAGER,
          UserRole.ADMIN,
          UserRole.SUPER_ADMIN,
          UserRole.RESERVATIONS,
          UserRole.RESERVATION_MANAGER,
          UserRole.RESERVATION_AGENT,
          UserRole.HOSPITALITY_MANAGER,
          UserRole.HOSPITALITY_AGENT,
          UserRole.GES,
          UserRole.OPERATION_MANAGER,
          UserRole.COMMERCIAL_MANAGER
        ]
      }
    }
  },
  GUEST_MANAGEMENT_MODULE: {
    PATH: '/guest-management',
    FULL_PATH: '/guest-management',
    DISPLAY_NAME: 'Guest Management',
    NAME: 'guest-management',
    IS_MENU: false,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: true,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/user-profile.svg`,
    PERMITTED_ROLES: [UserRole.SUPER_ADMIN],
    CHILDREN: {
      SEARCH: {
        PATH: '/search',
        FULL_PATH: '/guest-management/search',
        NAME: 'Guest Management Search',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: true,
        PERMITTED_ROLES: [UserRole.SUPER_ADMIN]
      }
    }
  },
  USER_MANAGEMENT_MODULE: {
    PATH: '/user-management',
    FULL_PATH: '/user-management',
    DISPLAY_NAME: 'User Management',
    NAME: 'user-management',
    IS_MENU: false,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: true,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/user-profile.svg`,
    PERMITTED_ROLES: [UserRole.SUPER_ADMIN],
    CHILDREN: {
      SEARCH: {
        PATH: '/search',
        FULL_PATH: '/user-management/search',
        NAME: 'User Management Search',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: true,
        PERMITTED_ROLES: [UserRole.SUPER_ADMIN]
      }
    }
  },
  BOOKING_MODULE: {
    PATH: '/booking',
    FULL_PATH: '/booking',
    DISPLAY_NAME: ' Booking Requests',
    NAME: ' Booking Requests',
    IS_MENU: true,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: false,
    NOTIFICATIONS_KEY: 'bookingRequests',
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/amenities.svg`,
    PERMITTED_ROLES: [
      UserRole.RESERVATION_AGENT,
      UserRole.RESERVATION_MANAGER,
      UserRole.ADMIN,
      UserRole.SUPER_ADMIN,
      UserRole.COMMERCIAL_MANAGER,
      UserRole.RESERVATIONS
    ],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/booking/list',
        NAME: ' Booking Requests List',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.RESERVATION_AGENT,
          UserRole.RESERVATION_MANAGER,
          UserRole.ADMIN,
          UserRole.SUPER_ADMIN,
          UserRole.COMMERCIAL_MANAGER,
          UserRole.RESERVATIONS
        ]
      }
    }
  },
  BLOCK_DATES_MODULE: {
    PATH: '/block-dates',
    FULL_PATH: '/block-dates',
    DISPLAY_NAME: 'Block Dates',
    NAME: 'Block Dates',
    IS_MENU: true,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: false,
    NOTIFICATIONS_KEY: 'blockDates',
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/amenities.svg`,
    PERMITTED_ROLES: [
      UserRole.RESERVATION_AGENT,
      UserRole.RESERVATION_MANAGER,
      UserRole.ECOMMERCE_SPECIALIST,
      UserRole.ECOMMERCE_SENIOR_SPECIALIST,
      UserRole.RESERVATIONS,
      UserRole.OPERATION_MANAGER,
      UserRole.ADMIN,
      UserRole.SUPER_ADMIN
    ],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/block-dates/list',
        NAME: 'Block Dates List',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.RESERVATION_AGENT,
          UserRole.RESERVATION_MANAGER,
          UserRole.ECOMMERCE_SPECIALIST,
          UserRole.ECOMMERCE_SENIOR_SPECIALIST,
          UserRole.RESERVATIONS,
          UserRole.OPERATION_MANAGER,
          UserRole.SUPER_ADMIN,
          UserRole.ADMIN
        ]
      }
    }
  },
  PROPERTY_MODULE: {
    PATH: '/properties',
    FULL_PATH: '/properties',
    DISPLAY_NAME: 'Projects',
    NAME: 'projects',
    IS_MENU: false,
    IS_MENU_LOOKUP: true,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/pngs/side-nav/area.png`,
    PERMITTED_ROLES: [
      UserRole.E_COMMERCE,
      UserRole.ECOMMERCE_SPECIALIST,
      UserRole.ECOMMERCE_SENIOR_SPECIALIST,
      UserRole.OPERATION_MANAGER,
      UserRole.HOSPITALITY_MANAGER,
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN
    ],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/properties/list',
        NAME: 'Projects List',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.E_COMMERCE,
          UserRole.ECOMMERCE_SPECIALIST,
          UserRole.ECOMMERCE_SENIOR_SPECIALIST,
          UserRole.OPERATION_MANAGER,
          UserRole.HOSPITALITY_MANAGER,
          UserRole.SUPER_ADMIN,
          UserRole.ADMIN
        ]
      },
      EDIT: {
        PATH: '/edit/:id',
        FULL_PATH: '/properties/edit/:id',
        NAME: 'Edit Project',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.E_COMMERCE,
          UserRole.ECOMMERCE_SPECIALIST,
          UserRole.ECOMMERCE_SENIOR_SPECIALIST,
          UserRole.OPERATION_MANAGER,
          UserRole.SUPER_ADMIN,
          UserRole.ADMIN
        ]
      }
    }
  },
  UNIT_TYPE_MODULE: {
    PATH: '/unit-types',
    FULL_PATH: '/unit-types',
    DISPLAY_NAME: 'Unit Types',
    NAME: 'unit-types',
    IS_MENU: false,
    IS_MENU_LOOKUP: true,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/unit-types.svg`,
    PERMITTED_ROLES: [
      UserRole.E_COMMERCE,
      UserRole.ECOMMERCE_SPECIALIST,
      UserRole.ECOMMERCE_SENIOR_SPECIALIST,
      UserRole.HOSPITALITY_MANAGER,
      UserRole.OPERATION_MANAGER,
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN
    ],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/unit-types/list',
        NAME: 'projects List',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.E_COMMERCE,
          UserRole.ECOMMERCE_SPECIALIST,
          UserRole.ECOMMERCE_SENIOR_SPECIALIST,
          UserRole.RESERVATION_MANAGER,
          UserRole.HOSPITALITY_MANAGER,
          UserRole.OPERATION_MANAGER,
          UserRole.SUPER_ADMIN,
          UserRole.ADMIN
        ]
      },
      EDIT: {
        PATH: '/edit/:id',
        FULL_PATH: '/unit-types/edit/:id',
        NAME: 'Edit project',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.E_COMMERCE,
          UserRole.ECOMMERCE_SPECIALIST,
          UserRole.ECOMMERCE_SENIOR_SPECIALIST,
          UserRole.RESERVATION_MANAGER,
          UserRole.OPERATION_MANAGER,
          UserRole.SUPER_ADMIN,
          UserRole.ADMIN
        ]
      }
      // BULK_EDIT: {
      //   PATH: '/bulk-edit/',
      //   FULL_PATH: '/unit-types/bulk-edit',
      //   NAME: 'Edit project',
      //   DISPLAY_NAME: 'Unit Types Bulk Update',
      //   IS_MENU: false,
      //   IS_MENU_LOOKUP: true,
      //   IS_MENU_USERS: false,
      //   ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/bulk-edit.svg`,
      //   PERMITTED_ROLES: [
      //     UserRole.E_COMMERCE,
      //     UserRole.ECOMMERCE_SPECIALIST,
      //     UserRole.ECOMMERCE_SENIOR_SPECIALIST,
      //     UserRole.SUPER_ADMIN,
      //     UserRole.ADMIN
      //   ]
      // },
      // BULK_EDIT_LIST: {
      //   PATH: '/bulk-edit-list/',
      //   FULL_PATH: '/unit-types/bulk-edit-list',
      //   NAME: 'Edit project',
      //   DISPLAY_NAME: 'Unit Types Bulk Update list',
      //   IS_MENU: false,
      //   IS_MENU_LOOKUP: false,
      //   IS_MENU_USERS: false,
      //   ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/bulk-list.svg`,
      //   PERMITTED_ROLES: [
      //     UserRole.E_COMMERCE,
      //     UserRole.ECOMMERCE_SPECIALIST,
      //     UserRole.ECOMMERCE_SENIOR_SPECIALIST,
      //     UserRole.SUPER_ADMIN,
      //     UserRole.ADMIN
      //   ]
      // }
    }
  },
  UNIT_LIFE_CYCLE_MODULE: {
    PATH: '/unit-life-cycle',
    FULL_PATH: '/unit-life-cycle',
    DISPLAY_NAME: 'Unit Life Cycle',
    NAME: 'unit-life-cycle',
    IS_MENU: true,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/unit-types.svg`,
    PERMITTED_ROLES: [UserRole.SUPER_ADMIN,UserRole.ADMIN,UserRole.ECOMMERCE_SENIOR_SPECIALIST,UserRole.ECOMMERCE_SPECIALIST]
  },
  EXPENSES_MODULE: {
    PATH: '/expenses',
    FULL_PATH: '/expenses',
    DISPLAY_NAME: 'Expenses',
    NAME: 'expenses',
    IS_MENU: false,
    IS_MENU_LOOKUP: true,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/expenses.svg`,
    PERMITTED_ROLES: [
      UserRole.E_COMMERCE,
      UserRole.FINANCE_MANAGER,
      UserRole.FINANCE_SPECIALIST,
      UserRole.OPERATION_MANAGER,
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN
    ]
  },
  PAYOUT_MODULE: {
    PATH: '/payout',
    FULL_PATH: '/payout',
    DISPLAY_NAME: 'Payout',
    NAME: 'payout',
    IS_MENU: false,
    IS_MENU_LOOKUP: true,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/payout.svg`,
    PERMITTED_ROLES: [
      UserRole.E_COMMERCE,
      UserRole.FINANCE_MANAGER,
      UserRole.ADMIN,
      UserRole.SUPER_ADMIN,
      UserRole.FINANCE_SPECIALIST
    ]
  },
  RESERVATION_MODULE: {
    PATH: '/reservations',
    FULL_PATH: '/reservations',
    DISPLAY_NAME: 'Reservations',
    NAME: 'reservations',
    IS_MENU: true,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: false,
    NOTIFICATIONS_KEY: 'reservations',
    ICON: `${PUBLIC_PATH}/assets/pngs/side-nav/reservation.png`,
    PERMITTED_ROLES: [
      UserRole.RESERVATION_AGENT,
      UserRole.RESERVATION_MANAGER,
      UserRole.ADMIN,
      UserRole.SUPER_ADMIN,
      UserRole.COMMERCIAL_MANAGER,
      UserRole.RESERVATIONS,
      UserRole.HOSPITALITY_AGENT,
      UserRole.GES,
      UserRole.HOSPITALITY_MANAGER,
      UserRole.FINANCE_MANAGER,
      UserRole.FINANCE_SPECIALIST,
      UserRole.OPERATION_MANAGER,
      UserRole.ECOMMERCE_SENIOR_SPECIALIST,
      UserRole.SALES_SPECIALIST,
      UserRole.SALES_MANAGER
    ],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/reservations/list',
        NAME: 'Reservations List',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.RESERVATION_AGENT,
          UserRole.RESERVATION_MANAGER,
          UserRole.ADMIN,
          UserRole.SUPER_ADMIN,
          UserRole.COMMERCIAL_MANAGER,
          UserRole.RESERVATIONS,
          UserRole.SALES_SPECIALIST,
          UserRole.SALES_MANAGER,
          UserRole.HOSPITALITY_AGENT,
          UserRole.GES,
          UserRole.HOSPITALITY_MANAGER,
          UserRole.FINANCE_MANAGER,
          UserRole.FINANCE_SPECIALIST,
          UserRole.OPERATION_MANAGER,
          UserRole.ECOMMERCE_SENIOR_SPECIALIST
        ]
      },
      EDIT: {
        PATH: '/edit/:id',
        FULL_PATH: '/reservations/edit/:id',
        NAME: 'Edit Reservation',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.RESERVATION_AGENT,
          UserRole.RESERVATION_MANAGER,
          UserRole.ADMIN,
          UserRole.SUPER_ADMIN,
          UserRole.COMMERCIAL_MANAGER,
          UserRole.RESERVATIONS,
          UserRole.SALES_SPECIALIST,
          UserRole.SALES_MANAGER,
          UserRole.HOSPITALITY_AGENT,
          UserRole.GES,
          UserRole.HOSPITALITY_MANAGER,
          UserRole.FINANCE_MANAGER,
          UserRole.FINANCE_SPECIALIST,
          UserRole.OPERATION_MANAGER,
          UserRole.ECOMMERCE_SENIOR_SPECIALIST
        ]
      },
      EDIT_NEW: {
        PATH: 'edit-new/:id',
        FULL_PATH: '/reservations/edit-new/:id',
        NAME: 'New Edit Reservation',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.RESERVATION_AGENT,
          UserRole.RESERVATION_MANAGER,
          UserRole.ADMIN,
          UserRole.SUPER_ADMIN,
          UserRole.COMMERCIAL_MANAGER,
          UserRole.RESERVATIONS,
          UserRole.SALES_SPECIALIST,
          UserRole.SALES_MANAGER,
          UserRole.HOSPITALITY_AGENT,
          UserRole.GES,
          UserRole.HOSPITALITY_MANAGER,
          UserRole.FINANCE_MANAGER,
          UserRole.FINANCE_SPECIALIST,
          UserRole.OPERATION_MANAGER,
          UserRole.ECOMMERCE_SENIOR_SPECIALIST
        ]
      },
      FEEDBACK_LIST: {
        PATH: '/feedbacks',
        FULL_PATH: '/reservations/feedbacks',
        DISPLAY_NAME: 'Feedbacks',
        NAME: 'feedbacks',
        IS_MENU: false,
        IS_MENU_LOOKUP: true,
        IS_MENU_USERS: false,
        ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/feedback.svg`,
        PERMITTED_ROLES: [
          UserRole.ADMIN,
          UserRole.SUPER_ADMIN,
          UserRole.HOSPITALITY_AGENT,
          UserRole.GES,
          UserRole.HOSPITALITY_MANAGER,
          UserRole.OPERATION_MANAGER
        ]
      },
      FEEDBACK_DETAILS: {
        PATH: '/feedback/:id',
        FULL_PATH: '/reservations/feedback/:id',
        NAME: 'Feedback details',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.ADMIN,
          UserRole.SUPER_ADMIN,
          UserRole.HOSPITALITY_AGENT,
          UserRole.GES,
          UserRole.HOSPITALITY_MANAGER,
          UserRole.OPERATION_MANAGER
        ]
      }
    }
  },
  OPERATION_MODULE: {
    PATH: '/operation',
    FULL_PATH: '/operation',
    DISPLAY_NAME: 'Operation',
    NAME: 'Operation',
    IS_MENU: true,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: false,
    IS_COLLAPSIBLE: true,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/amenities.svg`,
    PERMITTED_ROLES: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.OPERATION_MANAGER,
      UserRole.HOSPITALITY_MANAGER,
      UserRole.GES,
      UserRole.HOSPITALITY_AGENT,
      UserRole.HOUSE_KEEPING_MANAGER,
      UserRole.HOUSE_KEEPING
    ],
    CHILDREN: {
      OPERATION: {
        PATH: '/operation',
        FULL_PATH: '/operation',
        DISPLAY_NAME: 'Operation',
        NAME: 'Operation',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        IS_SUBMENU: true,
        PERMITTED_ROLES: [
          UserRole.SUPER_ADMIN,
          UserRole.ADMIN,
          UserRole.OPERATION_MANAGER,
          UserRole.HOSPITALITY_MANAGER,
          UserRole.GES,
          UserRole.HOSPITALITY_AGENT,
          UserRole.HOUSE_KEEPING_MANAGER,
          UserRole.HOUSE_KEEPING
        ]
      },
      MAINTENANCE: {
        PATH: '/maintenance',
        FULL_PATH: '/maintenance',
        DISPLAY_NAME: 'Operation Maintenance',
        NAME: 'Operation Maintenance',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        IS_SUBMENU: true,
        PERMITTED_ROLES: [UserRole.SUPER_ADMIN]
      },
      DAILY_OPERATIONS: {
        PATH: '/daily-operations',
        FULL_PATH: '/daily-operations',
        DISPLAY_NAME: 'Daily Operations',
        NAME: 'Daily Operations',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        IS_SUBMENU: true,
        PERMITTED_ROLES: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.OPERATION_MANAGER]
      },
      HOUSE_KEEPING: {
        PATH: '/house-keeping',
        FULL_PATH: '/house-keeping',
        DISPLAY_NAME: 'House Keeping',
        NAME: 'House Keeping',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        IS_SUBMENU: true,
        PERMITTED_ROLES: [
          UserRole.SUPER_ADMIN,
          UserRole.ADMIN,
          UserRole.OPERATION_MANAGER,
          UserRole.HOUSE_KEEPING,
          UserRole.HOUSE_KEEPING_MANAGER
        ]
      },
      HOUSE_KEEPING_LIST: {
        PATH: '/housekeeping-list',
        FULL_PATH: '/housekeeping-list',
        DISPLAY_NAME: 'House Keeping List',
        NAME: 'House Keeping List',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        IS_SUBMENU: true,
        PERMITTED_ROLES: [
          UserRole.SUPER_ADMIN,
          UserRole.ADMIN,
          UserRole.OPERATION_MANAGER,
          UserRole.HOUSE_KEEPING_MANAGER
        ]
      },
      GES: {
        PATH: '/ges',
        FULL_PATH: '/ges',
        DISPLAY_NAME: 'GES',
        NAME: 'GES',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        IS_SUBMENU: true,
        PERMITTED_ROLES: GES_PERMITTED_ROLES
      },
      CX_QUEUE: {
        PATH: '/cx-queue',
        FULL_PATH: '/cx-queue',
        DISPLAY_NAME: 'CX Queue',
        NAME: 'CX Queue',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        IS_SUBMENU: true,
        PERMITTED_ROLES: CX_QUEUE_PERMITTED_ROLES
      }
    }
  },
  PROMOCODE_MODULE: {
    PATH: '/promocode',
    FULL_PATH: '/promocode',
    DISPLAY_NAME: 'Promo Code',
    NAME: 'promocode',
    IS_MENU: true,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/promo-code.svg`,
    PERMITTED_ROLES: [UserRole.SUPER_ADMIN]
  },
  COMPANY_MODULE: {
    PATH: '/companies',
    FULL_PATH: '/companies',
    DISPLAY_NAME: 'Companies',
    NAME: 'companies',
    IS_MENU: false,
    IS_MENU_LOOKUP: true,
    IS_MENU_USERS: false,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/amenities.svg`,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.RESERVATIONS],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/companies/list',
        NAME: 'Companies List',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.RESERVATIONS]
      }
    }
  },
  PAYMENTS_MODULE: {
    PATH: '/payments',
    FULL_PATH: '/payments',
    DISPLAY_NAME: 'Payments',
    NAME: 'payments',
    IS_MENU: false,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: true,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/payments.svg`,
    PERMITTED_ROLES: [
      UserRole.FINANCE_MANAGER,
      UserRole.ADMIN,
      UserRole.SUPER_ADMIN,
      UserRole.FINANCE_SPECIALIST,
      UserRole.RESERVATION_MANAGER,
      UserRole.RESERVATIONS,
      UserRole.OPERATION_MANAGER
    ],
    CHILDREN: {
      LIST: {
        PATH: '/list',
        FULL_PATH: '/payments/list',
        NAME: 'Payments List',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: false,
        PERMITTED_ROLES: [
          UserRole.FINANCE_MANAGER,
          UserRole.ADMIN,
          UserRole.SUPER_ADMIN,
          UserRole.FINANCE_SPECIALIST,
          UserRole.RESERVATION_MANAGER,
          UserRole.RESERVATIONS,
          UserRole.OPERATION_MANAGER
        ]
      }
    }
  },
  // REPORTS_MODULE: {
  //   PATH: '/reports',
  //   FULL_PATH: '/reports',
  //   DISPLAY_NAME: 'Reports',
  //   NAME: 'Reports',
  //   IS_MENU: false,
  //   IS_MENU_LOOKUP: false,
  //   IS_MENU_USERS: false,
  //   ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/reports.svg`,
  //   PERMITTED_ROLES: [
  //     UserRole.FINANCE_MANAGER,
  //     UserRole.ADMIN,
  //     UserRole.SUPER_ADMIN,
  //     UserRole.FINANCE_SPECIALIST
  //   ],
  //   CHILDREN: {
  //     FINANCIAL: {
  //       PATH: '/financial',
  //       FULL_PATH: '/reports/financial',
  //       NAME: 'Financial Report',
  //       ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/financial-report.svg`,
  //       DISPLAY_NAME: 'Financial Report',
  //       IS_MENU: false,
  //       IS_MENU_LOOKUP: true,
  //       IS_MENU_USERS: false,
  //       PERMITTED_ROLES: [
  //         UserRole.FINANCE_MANAGER,
  //         UserRole.ADMIN,
  //         UserRole.SUPER_ADMIN,
  //         UserRole.FINANCE_SPECIALIST
  //       ]
  //     }
  //   }
  // },
  FURNISHING_MANAGEMENT_MODULE: {
    PATH: '/furnishing-main',
    FULL_PATH: '/furnishing-main',
    DISPLAY_NAME: 'Furnishing',
    NAME: 'furnishing-management',
    IS_MENU: false,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: true,
    IS_COLLAPSIBLE: true,
    NEW_LABEL: true,
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/user-profile.svg`,
    PERMITTED_ROLES: [
      UserRole.SUPER_ADMIN,
      UserRole.ADMIN,
      UserRole.DESIGN_TEAM,
      UserRole.DESIGN_MANAGER,
      UserRole.SALES_SPECIALIST,
      UserRole.SALES_MANAGER,
      UserRole.SALES_MANAGER
    ],
    CHILDREN: {
      PACKAGES: {
        PATH: '/packages',
        FULL_PATH: '/packages',
        DISPLAY_NAME: 'Packages',
        NAME: 'Furnishing Packages',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: true,
        IS_SUBMENU: true,
        PERMITTED_ROLES: [
          UserRole.SUPER_ADMIN,
          UserRole.ADMIN,
          UserRole.DESIGN_MANAGER,
          UserRole.DESIGN_TEAM
        ]
      },
      REQUESTS: {
        PATH: '/requests',
        FULL_PATH: '/requests',
        DISPLAY_NAME: 'Requests',
        NAME: 'Furnishing Requests',
        IS_MENU: false,
        IS_MENU_LOOKUP: false,
        IS_MENU_USERS: true,
        IS_SUBMENU: true,
        PERMITTED_ROLES: [
          UserRole.SUPER_ADMIN,
          UserRole.ADMIN,
          UserRole.DESIGN_TEAM,
          UserRole.DESIGN_MANAGER,
          UserRole.SALES_SPECIALIST,
          UserRole.SALES_MANAGER,
          UserRole.SALES_MANAGER
        ]
      }
    }
  }
};

export const SETTINGS_ROUTES: RouteConfig = {
  // ACCOUNT_SETTINGS_MODULE: {
  //   PATH: '/settings',
  //   FULL_PATH: '/setting',
  //   DISPLAY_NAME: 'Account Settings',
  //   IS_MENU: true,
  //   IS_MENU_LOOKUP: false,
  //   IS_MENU_USERS: false,
  //   NAME: 'account settings',
  //   ICON: `${PUBLIC_PATH}/assets/pngs/side-nav/settings.png`
  // },
  ACCOUNT_CONFIGURATION_MODULE: {
    PATH: '/configuration',
    FULL_PATH: '/configuration',
    DISPLAY_NAME: 'Configuration',
    IS_MENU: true,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: false,
    NAME: 'configuration',
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/settings.svg`,
    PERMITTED_ROLES: [UserRole.ADMIN, UserRole.SUPER_ADMIN]
  },
  USER_PROFILE_MODULE: {
    PATH: '/user-profile',
    FULL_PATH: '/user-profile',
    DISPLAY_NAME: 'Profile',
    IS_MENU: true,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: false,
    NAME: 'user profile',
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/user-profile.svg`
  },
  LOGOUT_MODULE: {
    PATH: '/logout',
    FULL_PATH: '/logout',
    DISPLAY_NAME: 'Logout',
    IS_MENU: true,
    IS_MENU_LOOKUP: false,
    IS_MENU_USERS: false,
    NAME: 'logout',
    ICON: `${PUBLIC_PATH}/assets/svgs/side-nav/logout.svg`
  }
};
